import { SerializedData } from 'bernie-core';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';

import Fields = ActivityDestinationViewSearch.__Fields;

/**
 *
 * ******************** TODO *****************************
 * Need to standardize on one sortAndFilter mapping.
 * The UI should not be handling complex mapping as below.
 * *******************************************************
 *
 */

export const initializeSortAndFilterObject = (
  universalSortAndFilter: ActivityDestinationViewSearch.UniversalSortAndFilter
): SerializedData => {
  let filters: SerializedData | undefined = {};
  let keywordPlaceholder = '';
  let keywordValue = '';
  universalSortAndFilter?.filterSections?.forEach(
    (filterSection: ActivityDestinationViewSearch.__ShoppingSortAndFilterSectionInlineFragment) => {
      filters = filterSection.fields?.reduce((map: SerializedData, current: Fields) => {
        if (current.__typename === 'ShoppingTextInputField') {
          map[current.id] = map[current.id] || {};
          current = current as ActivityDestinationViewSearch.ShoppingTextInputFieldInlineFragment;
          keywordPlaceholder = current.placeholder || '';
          keywordValue = current.selected || '';
        } else {
          current = current as ActivityDestinationViewSearch.ShoppingMultiSelectionFieldInlineFragment;
          current.options?.forEach((option) => {
            map[option.id] = map[option.id] || {};
            map[option.id][option.value] = { selected: option.selected, enabled: !option.disabled };
            if (option.nestedOptions && option.nestedOptions.length > 0) {
              option.nestedOptions.forEach((nestedOption) => {
                map[option.id][nestedOption.value] = {
                  selected: nestedOption.selected,
                  enabled: !nestedOption.disabled,
                };
              });
            }
          });
        }

        return map;
      }, {});
    }
  );

  return { filters, keywordPlaceholder, keywordValue };
};
